// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'robot-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.576 10.512v3.384m16.848-3.384v3.384M9 6.768V4.464m0 0A1.872 1.872 0 1 0 9 .72a1.872 1.872 0 0 0 0 3.744zm5.112 2.304c.864 0 1.512.648 1.512 1.512v7.488c0 .863-.648 1.512-1.512 1.512H3.96c-.864 0-1.512-.648-1.512-1.512V8.28c0-.864.648-1.512 1.512-1.512zm-8.496 6.92a1 1 0 1 0 0 2h6.768a1 1 0 0 0 0-2zm.36-5.256a2.153 2.153 0 0 0-2.152 2.152l.011.22a2.153 2.153 0 0 0 2.142 1.931l.22-.01a2.153 2.153 0 0 0 1.92-1.921l.01-.22a2.153 2.153 0 0 0-1.93-2.142zm6.048 0a2.153 2.153 0 0 0-2.152 2.152l.01.22a2.153 2.153 0 0 0 2.142 1.931l.22-.01a2.153 2.153 0 0 0 1.921-1.921l.01-.22a2.153 2.153 0 0 0-1.93-2.142z'
  />
);

export const viewBox = '0 0 18 18';
